<template>
	<div style="width: 95%;margin: 0 auto;">
		<div
			style="width: 100%;height: 30px;border-left: 3px solid red;margin-top: 25px;font-size: 24px;font-weight: 800;padding-left: 25px;">
			基础设置
		</div>

		<div @click="gotosb"
			style="width: 200px;height: 30px;border: 1px solid #000;text-align: center;line-height: 30px;margin-top: 10px;">
			修改个人资料
		</div>
		<div style="width: 100%;min-height: 300px;margin-top: 25px;">
			<div v-show="isShow">
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size: 16px;">
						头像:
					</div>
					<el-upload class="upload-demo" style="width: 200px;height: 30px;margin-top: 10px;float: left;"
						action="https://admin.shipoe360.com/api/picture/upload_pic" :on-preview="handlePreview"
						:on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handsuccessss" :limit="1"
						:on-exceed="handleExceed" :file-list="fileListss">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</div>
				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						昵称:
					</div>
					<el-input v-model="form.nickname" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				<div style="width: 100%;height: 50px;margin-top: 25px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						手机号:
					</div>
					<el-input v-model="form.mobphone" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						密码:
					</div>
					<el-input v-model="form.password" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						性别:
					</div>
					<el-radio-group  v-model="form.sex" style="float: left;width: 70%;margin-top: 20px;">
						<el-radio :label="1">男</el-radio>
						<el-radio :label="2">女</el-radio>
						<el-radio :label="0">保密</el-radio>
					</el-radio-group>
				</div>
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						邮箱:
					</div>
					<el-input v-model="form.email" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						真实姓名:
					</div>
					<el-input v-model="form.truename" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				<div style="width: 100%;height: 50px;">
					<div
						style="width: 20%;height: 50px;float: left;line-height: 50px;text-align: center;font-size:16px;">
						证件号码:
					</div>
					<el-input v-model="form.idcard" style="float: left;width: 70%;margin-top: 5px;"></el-input>
				</div>
				<div style="height: 50px;width: 200px;margin: 0 auto;">
					<el-button type="primary" @click="onSubmit">立即创建</el-button>
					<el-button @click="isShow = !isShow">取消</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				isShow: false,
				imageUrl: '',
				label:0,
				form: {
					name: '',
					password: '',
					nickname: '',
					truename: '',
					idcard: '',
					resource: '',
					desc: '',
					imageUrl: '',
					email: '',
					sex: '',
					mobphone:'',
				},
				cnmuid: '',
				fileListss: [],
				contems: '',
			}
		},
		mounted() {
			const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
			if (loginInfo) {
				console.log(1)
			}else{
				console.log(2)
				this.$router.push('/login')
			}
		},
		methods: {
			async gotosb() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.get('api/picture/grzx', {
					uid: loginInfo.id
				})
				this.contems = res.data.data[0]
				console.log(this.contems)
				this.isShow = !this.isShow
				
				this.form.idcard = this.contems.idcard
				this.form.truename = this.contems.truename
				this.form.email = this.contems.email
				this.form.sex = this.contems.sex
				this.label = this.contems.sex
				this.form.password = this.contems.password
				this.form.nickname = this.contems.nickname
				this.form.icon = this.contems.icon
				this.form.mobphone = this.contems.mobphone
				
				let fileArrss = [];
				let fileObjss = {};
				fileObjss.name="图片";
				fileObjss.url = this.form.icon;
				fileArrss.push(fileObjss);
				this.fileListss  = fileArrss
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
				this.form.icon = res.data.path
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},
			handsuccessss(response, file, fileList) {
				this.form.icon = response.data.path
			},
			beforeAvatarUpload(file) {

			},
			async onSubmit() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				this.cnmuid = loginInfo.id
				let res = await http.post('api/picture/grzx_edit', {
					uid: this.cnmuid,
					nickname: this.form.nickname,
					password: this.form.password,
					sex: this.form.sex,
					email: this.form.email,
					truename: this.form.truename,
					icon: this.form.icon,
					idcard: this.form.idcard,
					mobphone: this.form.mobphone
				})
				console.log(res)
				this.$message(res.data.msg);
				this.$parent.getinfo()
				this.fileListss = []
				this.form.nickname = ''
				this.form.password = ''
				this.form.sex = ''
				this.form.email = ''
				this.form.truename = ''
				this.form.icon = ''
				this.form.idcard = ''
				this.form.mobphone = ''
				this.isShow = false
			}
		}
	}
</script>

<style>
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	/deep/ .el-upload__input {
		display: none;
	}
</style>
